export const PAGINATION_DEFAULT_VALUE = {
    pageSize: 10,
    totalPages: 0,
    totalItems: 0,
    currentPage: 0,
};
